/**
 * Subscriptions admin list status filter.
 *
 * The list defaults to `active` (active + trialing) so canceled/expired
 * records don't clutter the primary view; `all` and the individual
 * statuses are available for investigation.
 */

import type { SubscriptionStatus } from '../types/subscription';

export type SubscriptionStatusFilter = 'active' | 'all' | SubscriptionStatus;

export const DEFAULT_SUBSCRIPTION_STATUS_FILTER: SubscriptionStatusFilter = 'active';

export const SUBSCRIPTION_STATUS_FILTER_OPTIONS: ReadonlyArray<{
  value: SubscriptionStatusFilter;
  label: string;
}> = [
  { value: 'active', label: 'Active' },
  { value: 'all', label: 'All' },
  { value: 'trialing', label: 'Trialing' },
  { value: 'past_due', label: 'Past Due' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'expired', label: 'Expired' },
  { value: 'incomplete', label: 'Incomplete' },
];

export function matchesSubscriptionStatusFilter(
  subscription: { status: SubscriptionStatus },
  filter: SubscriptionStatusFilter
): boolean {
  if (filter === 'all') {
    return true;
  }
  if (filter === 'active') {
    return subscription.status === 'active' || subscription.status === 'trialing';
  }
  return subscription.status === filter;
}
